// extracted by mini-css-extract-plugin
export var actionButton = "_o4-0";
export var actionMenuContainer = "_o4-i";
export var bubble = "_o4-2";
export var bubbleActionMenu = "_o4-j";
export var bubbleContext = "_o4-6";
export var bubbleItems = "_o4-7";
export var customer = "_o4-3";
export var divider = "_o4-8";
export var fileList = "_o4-9";
export var hiddenComment = "_o4-o";
export var infoAbove = "_o4-a";
export var internal = "_o4-4";
export var lightActionButton = "_o4-1";
export var link = "_o4-b";
export var merchant = "_o4-5";
export var message = "_o4-c";
export var profilePicture = "_o4-e";
export var quillToolbarContainer = "_o4-f";
export var senderDate = "_o4-g";
export var senderDateCustomer = "_o4-h";
export var senderName = "_o4-d";
export var time = "_o4-k";
export var uploadedImage = "_o4-l";
export var username = "_o4-m";
export var xsmall = "_o4-n";